import Nav from '../Components/Nav.js';
import '../styles/Footer.scss';

const Footer = $ =>
    <footer>
        <Nav id="secondary" {... $}/>
    </footer>

export default Footer;